import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
    defaults: {
    VCard: {
      rounded: 'xl',
      elevation: 0,
      border: true,
    },
    VBtn: {
      rounded: 'lg',
      elevation: 0,
    },
    VDialog: {
      VCard: {
        rounded: 'xl',
        elevation: 0,
        border: false,
      },
    },
    VMenu: {
      VCard: {
        rounded: 'lg',
        elevation: 3,
        border: false,
      },
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
      color: 'primary',
      bgColor: 'background',
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
      color: 'primary',
      bgColor: 'background',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
      color: 'primary',
      bgColor: 'background',
    },
    VCombobox: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
      color: 'primary',
      bgColor: 'background',
    },
    VTextarea: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'lg',
      color: 'primary',
      bgColor: 'background',
    },
    VChip: {
      rounded: 'xl',
    },
    VAlert: {
      rounded: 'lg',
    },
    VList: {
      rounded: 'lg',
    },
  },
  theme: {
    defaultTheme: 'paj',
    themes: {
      paj: {
        dark: false,
        colors: {
          // Palette Organique & Frais (Émeraude & Océan)
          primary: '#0F766E',    // Teal / Émeraude profond
          secondary: '#0284C7',  // Bleu ciel / Océan
          accent: '#EA580C',     // Corail / Orange énergique
          lowkey: '#334155',     // Ardoise neutre

          background: '#F8FAF9', // Fond neutre très doux légèrement teinté de vert d'eau
          surface: '#FFFFFF',    // Cartes blanches nettes

          error: '#DC2626',
          info: '#0284C7',
          success: '#16A34A',
          warning: '#D97706',
        },
      },
    },
    variations: {
      colors: ['background', 'primary', 'secondary', 'surface'],
      lighten: 2,
      darken: 2,
    },
  },
  icons: {
    defaultSet: 'mdi',
  },
});
